(function () {
    'use strict';

    angular
        .module('app')
        .factory('SecurityService', SecurityService);

    SecurityService.$inject = ['$http', 'UrlService'];

    function SecurityService($http, UrlService) {
        var service = {
            getEntityTemplateAcl: getEntityTemplateAcl,
            updateUserEntityTemplateAcl: updateUserEntityTemplateAcl
        };

        return service;

        /**
         * Get entity template ACL (access control list) for all entity templates.
         * Either get the defaults for all users, or defaults plus specific overrides for a given user.
         *
         * @param {number} userId - Optional. The entity ID of the user to get entity template ACL for.
         * @returns {promise} A promise that resolves an array of entity template ACL objects.
         */
        function getEntityTemplateAcl(userId) {
            var url = UrlService.getWebAPIUrl() + '/security/entityTemplateAcl/';

            if (!_.isNil(userId)) {
                url += '?userid=' + userId;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }

        /**
         * Update entity template ACL for the specified user.
         *
         * @param {number} userId - The entity ID of the user to update entity template ACL for.
         * @param {array} userEntityTemplateAcl - Array of {object} representing user entity template ACL.
         * @returns {promise} A promise that resolves once user entity template ACL is updated.
         */
        function updateUserEntityTemplateAcl(userId, userEntityTemplateAcl) {
            if (!angular.isNumber(userId)) {
                throw 'Cannot update user entity template security, provided user id is not a number';
            }

            return $http.put(UrlService.getWebAPIUrl() + '/entity/' + userId + '/entityTemplateAcl/', userEntityTemplateAcl)
                .then(function (response) {
                    return response.data;
                });
        }
    }
})();